import * as uuid from 'node-uuid';

type notification_types = 'success'|'error';

export const DEFAULT_TIMEOUT = 3000;

export class Notification {
    id: string;
    type: notification_types;
    message: string;
    timeout: number;

    constructor(
        type: notification_types,
        message: string,
        timeout: number = 3000
    ) {
        this.id = uuid.v4();
        this.type = type;
        this.message = message;
        this.timeout = timeout;
    }

    static success(message: string, timeout?: number) {
        return new Notification('success', message, timeout);
    }

    static error(message: string, timeout?: number) {
        return new Notification('error', message, timeout);
    }
}

class Notify {
    public notifications: Array<Notification>;

    constructor() {
        this.notifications = [];
    }

    addNotification(notification: Notification) {
        this.notifications.push(notification);
        window.setTimeout(() => {
            this.clear(notification);
        }, notification.timeout);
        return notification;
    }

    success(message: string, timeout?: number) {
        return this.addNotification(Notification.success(message, timeout));
    }

    error(message: string = "Oops, something went wrong.", timeout?: number) {
        return this.addNotification(Notification.error(message, timeout));
    }

    clear(notification: Notification) {
        const ix = this.notifications.indexOf(notification);
        this.notifications.splice(ix, 1);
    }
}

export const notify = new Notify();



// WEBPACK FOOTER //
// ./_src/services/notify/notify.ts